/* eslint-disable */
import { parsePhoneNumberFromString } from "libphonenumber-js";

export const VALID_BRAZILIAN_PHONE_NUMBER_LENGTH = 13;

export const regexCPF =
	/([0-9]{2}[\.]?[0-9]{3}[\.]?[0-9]{3}[\/]?[0-9]{4}[-]?[0-9]{2})|([0-9]{3}[\.]?[0-9]{3}[\.]?[0-9]{3}[-]?[0-9]{2})/gm;
export const regexEmail =
	/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const cpfMask = (value) => {
	return value
		.replace(/\D/g, "") // substitui qualquer caracter que nao seja numero por nada
		.replace(/(\d{3})(\d)/, "$1.$2") // captura 2 grupos de numero o primeiro de 3 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de numero
		.replace(/(\d{3})(\d)/, "$1.$2")
		.replace(/(\d{3})(\d{1,2})/, "$1-$2")
		.replace(/(-\d{2})\d+?$/, "$1"); // captura 2 numeros seguidos de um traço e não deixa ser digitado mais nada
};

export const regexName = /^[A-Za-zÀ-ú]{2,}\ [ A-Za-zÀ-ú]+$/g;
export const regexWhithoutSpace = /\s/g;

export const onlyNumbers = (value) => {
	return value.replace(/[^0-9]/g, "");
};
export const isCepValid = (cep) => {
	if (!cep) return false;
	let newValue = onlyNumbers(cep);
	return newValue.length === 8;
};
export const cepMask = (value) => {
	if (value.length === 8) {
		return `${value.substr(0, 5)}-${value.substr(5, 9)}`;
	}
	return value;
};
export const phoneMask = (value) => {
	const parsedNumber = parsePhoneNumberFromString("+" + value);
	const country = "+" + value.slice(0, 2) + " ";
	return country + parsedNumber.formatNational();
};

export function ValidateCreditCardNumber(ccNum) {
	var visaRegEx = /^(?:4[0-9]{12}(?:[0-9]{3})?)$/;
	var mastercardRegEx = /^(?:5[1-5][0-9]{14})$/;
	var amexpRegEx = /^(?:3[47][0-9]{13})$/;
	var discovRegEx = /^(?:6(?:011|5[0-9][0-9])[0-9]{12})$/;
	var isValid = true;

	if (visaRegEx.test(ccNum)) {
		isValid = true;
	} else if (mastercardRegEx.test(ccNum)) {
		isValid = true;
	} else if (amexpRegEx.test(ccNum)) {
		isValid = true;
	} else if (discovRegEx.test(ccNum)) {
		isValid = true;
	}

	if (isValid) {
		console.info("ValidateCreditCardNumber::Thank You!");
	} else {
		console.warn("ValidateCreditCardNumber::Please provide a valid Visa number!");
	}
	return isValid;
}

export const getPath = (path) => {
	// const origin = 'https://portal-alpha.trademapdev.com.br';
	// return origin + path;
	return document.location.origin + path;
};

/**
 *
 * @param {keyof typeof config} env
 */
export const getEnvironment = (env) => {
	return config[env];
};

export const descrambleString = (str) => {
	str = str.replace(/@/g, "=");
	let param = atob(str.toString());
	return param;
};

export const conf = async () => {
	const settings = require("../settings.json");
	return settings;
};

export const isMobile = {
	Android: function () {
		return navigator.userAgent.match(/Android/i);
	},
	BlackBerry: function () {
		return navigator.userAgent.match(/BlackBerry/i);
	},
	iOS: function () {
		return navigator.userAgent.match(/iPhone|iPad|iPod/i);
	},
	Opera: function () {
		return navigator.userAgent.match(/Opera Mini/i);
	},
	Windows: function () {
		return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
	},
	any: function () {
		return this.Android() || this.BlackBerry() || this.iOS() || this.Opera() || this.Windows();
	},
};

export const formattedPrice = (value = 0, minimumFractionDigits = 2) => {
	return new Intl.NumberFormat("pt-BR", {
		style: "currency",
		currency: "BRL",
		minimumFractionDigits,
	}).format(Number(parseFloat(String(value)).toFixed(minimumFractionDigits)));
};

export const changePath = (path) => {
	window.location.pathname = path;
};

const _getBrowser = () => {
	if (navigator.userAgent.match(/Chrome/i)) return "Google Chrome";
	if (navigator.userAgent.match(/Firefox/i)) return "Mozilla Firefox";
	if (navigator.userAgent.match(/Safari/i)) return "Apple Safari";
	if (navigator.userAgent.match(/Edge/i)) return "Microsoft Edge";
	if (navigator.userAgent.match(/Opera|OPR/i)) return "Opera";
};

const _getBrowserVersion = () => {
	const userAgent = navigator.userAgent;
	const browserRegex = /(Firefox|Chrome|Edg|Safari|Opera|OPR|MSIE|Trident)\/(\d+\.\d+\.\d+\.\d+|\d+\.\d+)/;
	const match = userAgent.match(browserRegex);

	if (match) {
		const browserVersion = match[2];
		return browserVersion;
	}

	return "1.0.0";
};

const _getPlatform = () => {
	if (/iPhone|iPod/i.test(navigator.userAgent)) return "O.S Apple";
	if (/iPad/i.test(navigator.userAgent)) return "iPadOS";
	if (/Android/i.test(navigator.userAgent)) return "O.S Google";
	if (/Win/i.test(navigator.userAgent)) return "Windows";
	if (/Mac/i.test(navigator.userAgent)) return "MacOS";
	if (/Linux/i.test(navigator.userAgent)) return "Linux";
};

export const browser = _getBrowser();
export const browserVersion = _getBrowserVersion();
export const platform = _getPlatform();

export const getSessionStorageKey = (key) => {
	let rep;

	try {
		rep = isJson(sessionStorage.getItem(key))
			? JSON.parse(sessionStorage.getItem(key))
			: sessionStorage.getItem(key);
	} catch (error) {
		rep = {};
	} finally {
		return rep;
	}
};

function isJson(value) {
	try {
		const isObject = JSON.parse(value);

		return typeof isObject === "object" && isObject !== null;
	} catch (err) {
		return false;
	}
}
/**
 * Retorna true se o valor é undefined
 */
export const isUndefined = (value) => {
	return value === undefined;
};
export const leftPad = (value, totalWidth, paddingChar) => {
	var length = totalWidth - value.toString().length + 1;
	return Array(length).join(paddingChar || "0") + value;
};
export const setSessionStorageKey = (key, value) => {
	sessionStorage.removeItem(key);
	sessionStorage.setItem(key, JSON.stringify(value));
};

export const removeStorageKey = (key) => {
	sessionStorage.removeItem(key);
	localStorage.removeItem(key);
};

export const isDataInStorageKey = (key) => {
	try {
		const isDataInSessionStorage = sessionStorage.getItem(key);
		const isDataInLocalStorage = localStorage.getItem(key);
		return (
			(isDataInSessionStorage && isDataInSessionStorage.length) ||
			(isDataInLocalStorage && isDataInLocalStorage.length)
		);
	} catch (error) {
		return false;
	}
};

const isScriptLoaded = (src) => {
	return document.querySelector('script[src="' + src + '"]') ? true : false;
};
export const useScript = (url) => {
	if (isScriptLoaded(url)) return;
	const script = document.createElement("script");
	script.src = url;
	script.async = true;
	document.body.appendChild(script);
};

export const event_conversion = (value) => {
	setTimeout(() => {
		window.dataLayer = window.dataLayer || [];
		function gtag() {
			dataLayer.push(arguments);
		}
		gtag("event", "conversion", {
			send_to: "AW-954635285/mBpnCNaf8NIBEJWomscD",
			value: value,
			currency: "BRL",
		});
	}, 300);
};
/**
 * Evento usado na conversão da compra de curso
 * @param {*} value
 */
export const event_conversion_course_opcoes = () => {
	setTimeout(() => {
		window.dataLayer = window.dataLayer || [];
		function gtag() {
			dataLayer.push(arguments);
		}
		gtag("event", "conversion", {
			send_to: "AW-848272923/OvPQCKvT0_ABEJu8vpQD",
			transaction_id: "",
		});
	}, 300);
};

export const initGA = (history) => {
	useScript("https://www.googletagmanager.com/gtag/js?id=AW-954635285");
	setTimeout(() => {
		window.dataLayer = window.dataLayer || [];
		function gtag() {
			dataLayer.push(arguments);
		}
		gtag("js", new Date());
		gtag("config", "AW-954635285", {
			cookie_flags: "SameSite=None; Secure",
		});
	}, 300);
};

export const initGA2 = (history) => {
	useScript("https://www.googletagmanager.com/gtag/js?id=AW-848272923");
	setTimeout(() => {
		window.dataLayer = window.dataLayer || [];
		function gtag() {
			dataLayer.push(arguments);
		}
		gtag("js", new Date());
		gtag("config", "AW-848272923", {
			cookie_flags: "SameSite=None; Secure",
		});
	}, 300);
};

export const initGTM = () => {
	setTimeout(() => {
		function gtmtag(w, d, s, l, i) {
			w[l] = w[l] || [];
			w[l].push({
				"gtm.start": new Date().getTime(),
				event: "gtm.js",
			});
			var f = d.getElementsByTagName(s)[0],
				j = d.createElement(s),
				dl = l != "dataLayer" ? "&l=" + l : "";
			j.async = true;
			j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
			f.parentNode.insertBefore(j, f);
		}

		gtmtag(window, document, "script", "dataLayer", "GTM-PC75V7P");
	}, 300);
};

/** Verifica se o objeto esta vazio*/
export const isEmpty = (obj) => {
	return !obj || !Object.keys(obj).length;
};

import bmfImage from "../assets/micro-services/bmf.png";
import euaImage from "../assets/micro-services/eua.png";
import listasImage from "../assets/micro-services/listas.png";
import reutersImage from "../assets/micro-services/reuters.png";
import estadaoImage from "../assets/micro-services/estadao.png";
import consensoImage from "../assets/micro-services/consenso.png";
import fundamentosImage from "../assets/micro-services/fundamentos.png";
import screenerImage from "../assets/micro-services/screener.png";
import indicadoresImage from "../assets/micro-services/indicadores.png";
import tradingviewImage from "../assets/micro-services/tradingview.png";
import payoutImage from "../assets/micro-services/payout.png";
import gregasImage from "../assets/micro-services/gregas.png";
import strikeImage from "../assets/micro-services/strike.png";
import proventosImage from "../assets/micro-services/proventos.png";
import rentabilidadeImage from "../assets/micro-services/rentabilidade.png";
import moment from "moment";
import config from "../config/ConfigApplication";
export const COMBOS_IMG = {
	COMBO_NOTICIAS: [reutersImage, estadaoImage],
	COMBO_MERCADO: [bmfImage, euaImage, listasImage],
	COMBO_FUNDAMENTALISTA: [consensoImage, fundamentosImage, screenerImage],
	COMBO_CARTEIRA: [euaImage, rentabilidadeImage, proventosImage],
	COMBO_AT: [indicadoresImage, tradingviewImage],
	COMBO_OPCOES: [payoutImage, gregasImage, strikeImage],
};

export const ICONS_PACKAGES = {
	//combo mercado
	STOCK_LIST_LIMIT_40: ["bmf.png", "eua.png", "listas.png"],
	MOVERS_PREMIUM: ["bmf.png", "eua.png", "listas.png"],
	MOVER_USA: ["bmf.png", "eua.png", "listas.png"],
	IOSMA_20ANOS: ["bmf.png", "eua.png", "listas.png"],
	CLASSES_PREMIUM: ["bmf.png", "eua.png", "listas.png"],
	FEED_US: ["bmf.png", "eua.png", "listas.png"],
	FEED_BMF_LIVE: ["bmf.png", "eua.png", "listas.png"],
	//combo noticias
	NEWS_PREMIUM: ["reuters.png", "estadao.png"],
	//combo explorer
	COMPANY_SHEET: ["consenso.png", "fundamentos.png", "screener.png"],
	MENU_EXPLORER: ["consenso.png", "fundamentos.png", "screener.png"],
	COMPANY_FULL_DETAIL: ["consenso.png", "fundamentos.png", "screener.png"],
	//combo carteira
	CUSTODY_EVOLUTION: [],
	CUSTODY_STATEMENT: [],
	CUSTODY_PROFIT: [],
	CUSTODY_SEGMENTED: [],
	CUSTODY_DASHBOARD: [],
	//combo analise tecnica
	AT_INDICATORS: ["indicadores.png", "tradingview.png"],
	//combo opcoes
	TOOLS_PREMIUM: ["payout.png", "gregas.png", "strike.png"],
};
export const ERROR_MESSAGES = {
	PAYMENT_BILLING_PLAN_ERROR: {
		title: "ops... houve uma falha na cobrança",
		tryAgain: true,
	},
	VALIDACAO_NAO_EFETUADA_COM_SUCESSO: {
		title: "ops... houve uma falha na validação do seu cartão",
		tryAgain: true,
	},
	// FREE_PLAN_ERROR:{
	//   title: false
	// },
	// RESEARCH_NOT_CHOOSED: {
	//   title: false
	// },
	BILL_ALREADY_APPLIED: {
		title: "ops... houve uma falha ao concluir operação",
		tryAgain: false,
	},
	ERROR_INSERIR_CARTAO: {
		title: "ops... houve uma falha ao validar seu cartão",
		tryAgain: true,
	},
	// ALREADY_HAVE_INSIDE_ACCOUNT:{
	//   title: false
	// }
};
/**
 * Creates an anchor element `<a></a>` with
 * the base64 pdf source and a filename with the
 * HTML5 `download` attribute then clicks on it.
 * @param  {string} pdf
 * @return {void}
 */
export const downloadPDF = (pdf, boleto_name = "BoletoTrademap") => {
	const linkSource = `data:application/pdf;base64,${pdf}`;
	const downloadLink = document.createElement("a");
	const fileName = `${boleto_name}.pdf`;

	downloadLink.href = linkSource;
	downloadLink.download = fileName;
	downloadLink.click();
};

export const getAge = (dateString, formatDate = false) => {
	let birthDate = new Date(dateString);
	if (formatDate) birthDate = new Date(moment(dateString, "DD/MM/YYYY").format("YYYY/MM/DD"));
	const today = new Date();
	let age = today.getFullYear() - birthDate.getFullYear();
	const m = today.getMonth() - birthDate.getMonth();
	if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) age--;
	return parseInt(age);
};

export const getUrlBaseEducaMap = (endPoint = "") => {
	config.educaRedirect;
	let educaUrl = "portal-educa.trademap.com.br";
	const isProduction = getSessionStorageKey("Enviroment");
	if (!isProduction) educaUrl = `${educaUrl.slice(0, 21)}dev${educaUrl.slice(21, 29)}`;
	educaUrl = `https://${educaUrl}${endPoint}`;
	return educaUrl;
};

export const hideCharactersEmail = (email) => {
	var hiddenEmail = "";
	var caracterEsp = /[^a-zA-Z 0-9]+/g;

	for (let i = 0; i < email.length; i++) {
		if (i >= 1 && i < email.indexOf("@") && !caracterEsp.test(email[i])) {
			hiddenEmail += "*";
		} else {
			hiddenEmail += email[i];
		}
	}
	return hiddenEmail;
};

export const validatingMaxBrazilianPhoneLength = (phone) => {
	const countryCodeBrazilian = phone.substr(0, 5).includes("55");
	const onlyNumbers = phone.replace(/\D/g, "");

	return countryCodeBrazilian && onlyNumbers.length != VALID_BRAZILIAN_PHONE_NUMBER_LENGTH
		? "Digite um número de celular válido"
		: "";
};

export const convertSecondsInMinutes = (value) => {
	const minutes = Math.floor(value / 60);
	const seconds = Math.floor(value % 60);

	return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
};

export const detectAutofill = (element) => {
	if (!element) return;

	return window.getComputedStyle(element, null).getPropertyValue("appearance") === "menulist-button";
};

export const waitTimeout = (timeoutLength = 0) => new Promise((resolve) => setTimeout(resolve, timeoutLength));

/**
 * Redirect to promotional or default route or any provided route
 * @param {string} router
 * @returns string
 */
export const redirectTo = (router = "/onboard/login") => {
	const fluxPromo = JSON.parse(localStorage.getItem("FLUX_PROMO"));

	return fluxPromo && fluxPromo.route ? fluxPromo.route : router;
};
